"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _styles = require("@material-ui/core/styles");
var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));
var _Tabs = _interopRequireDefault(require("@material-ui/core/Tabs"));
var _Tab = _interopRequireDefault(require("@material-ui/core/Tab"));
var _TabPanel = _interopRequireDefault(require("./TabPanel"));
var _meta = require("../_utils/meta");
var _lab = require("@material-ui/lab");
var _excluded = ["cq:panelTitle"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
var __jsx = _react.default.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var isBrowser = typeof window !== 'undefined';
function a11yProps(index) {
  return {
    id: "tab-".concat(index),
    'aria-controls': "tabpanel-".concat(index)
  };
}
function stripPathFromKey(key) {
  var strippedKey = key.split('/');
  return strippedKey[strippedKey.length - 1];
}
var useStyles = (0, _styles.makeStyles)(function (theme) {
  var _tab;
  return {
    root: (0, _defineProperty2.default)({
      flexGrow: 1,
      backgroundColor: theme.palette.background.paper,
      textTransform: 'none',
      '& .MuiSvgIcon-fontSizeSmall': {
        border: "1px solid ".concat(theme.palette.grey['400']),
        borderRadius: '50%'
      },
      '& .Mui-disabled': {},
      '& .MuiTabs-root': {
        minHeight: '36px',
        marginBottom: theme.spacing(4)
      },
      minWidth: '10px'
    }, theme.breakpoints.up('md'), {
      marginTop: theme.spacing(1),
      marginLeft: theme.spacing(3)
    }),
    indicator: {
      display: 'flex',
      justifyContent: 'center',
      backgroundColor: 'transparent',
      borderColor: 'transparent',
      color: 'transparent',
      '& > span': {
        maxWidth: '80px',
        width: '100%',
        backgroundColor: 'transparent',
        borderColor: 'transparent',
        color: 'transparent'
      }
    },
    tabTitle: (0, _defineProperty2.default)({
      letterSpacing: theme.typography.pxToRem(0.12),
      fontWeight: 'inherit',
      fontSize: theme.typography.pxToRem(12),
      color: theme.palette.primary.main
    }, theme.breakpoints.up('md'), {
      letterSpacing: theme.typography.pxToRem(0.18),
      fontWeight: theme.typography.fontWeightBold,
      fontSize: theme.typography.pxToRem(18)
    }),
    tab: (_tab = {
      textTransform: 'none',
      margin: theme.spacing(1.5, 0, 0),
      minWidth: '72px',
      minHeight: '36px',
      fontWeight: theme.typography.fontWeightMedium,
      borderBottom: '2px solid transparent',
      padding: theme.spacing(2.5, 4, 2),
      opacity: '1'
    }, (0, _defineProperty2.default)(_tab, theme.breakpoints.up('md'), {
      minHeight: '48px',
      minWidth: 'auto',
      maxWidth: 'none',
      borderBottomWidth: '4px',
      padding: theme.spacing(4, 4, 3)
    }), (0, _defineProperty2.default)(_tab, '&:focus', {
      color: theme.palette.common.black
    }), (0, _defineProperty2.default)(_tab, '&:hover:not(.Mui-selected)', {
      borderColor: theme.palette.primary.main
    }), (0, _defineProperty2.default)(_tab, '&.Mui-selected', {
      borderColor: theme.palette.common.black,
      zIndex: 10,
      '& span div': {
        color: theme.palette.common.black
      }
    }), _tab),
    tabsContainer: {
      position: 'relative',
      '&:after': {
        content: "''",
        display: 'block',
        height: '1px',
        width: '100%',
        backgroundColor: theme.palette.grey[400],
        position: 'absolute',
        bottom: 0,
        left: 0
      },
      '& .MuiTabScrollButton-root.Mui-disabled': {
        '& .MuiSvgIcon-fontSizeSmall': {
          opacity: 0
        }
      },
      '& .MuiTabs-scrollButtonsDesktop': {
        zIndex: 10,
        background: theme.palette.common.white,
        opacity: 1
      }
    }
  };
});
var setQueryParam = function setQueryParam(key, value) {
  var searchURL = isBrowser ? window.location.search : '';
  var searchParams = new URLSearchParams(searchURL);
  var currentValue = value || '';
  searchParams.set(key, currentValue);
  if (isBrowser) {
    var newurl = "".concat(window.location.protocol, "//").concat(window.location.host).concat(window.location.pathname, "?").concat(searchParams.toString());
    window.history.pushState({
      path: newurl
    }, '', newurl);
  }
};
var HorizontalTab = function HorizontalTab(props) {
  var classes = useStyles();
  var aemProps = props.aemProps,
    tabItems = props.tabItems;
  var propsToUse = aemProps ? _objectSpread(_objectSpread({}, props), aemProps) : props;
  var isAemEditMode = (0, _meta.getWcmmode)() === 'edit';
  var isAemPreviewMode = (0, _meta.getWcmmode)() === 'preview' || (0, _meta.getWcmmode)() === 'disabled';
  var _useState = (0, _react.useState)(true),
    showLoader = _useState[0],
    setShowLoader = _useState[1];
  // activeItem is string which contains the ID of the selected tab (comes from AEM)
  var items = propsToUse.items,
    cqItems = propsToUse.cqItems,
    _propsToUse$activeIte = propsToUse.activeItem,
    activeItem = _propsToUse$activeIte === void 0 ? '' : _propsToUse$activeIte,
    children = propsToUse.children,
    _propsToUse$userIsLog = propsToUse.userIsLoggedIn,
    userIsLoggedIn = _propsToUse$userIsLog === void 0 ? false : _propsToUse$userIsLog,
    _propsToUse$isBuyAgai = propsToUse.isBuyAgainEmpty,
    isBuyAgainEmpty = _propsToUse$isBuyAgai === void 0 ? false : _propsToUse$isBuyAgai,
    _propsToUse$translati = propsToUse.translations,
    translations = _propsToUse$translati === void 0 ? {
      popularProducts: 'Popular Products'
    } : _propsToUse$translati,
    _propsToUse$showHoriz = propsToUse.showHorizontaltabLoader,
    showHorizontaltabLoader = _propsToUse$showHoriz === void 0 ? false : _propsToUse$showHoriz;
  var HTabItems = items ? items : cqItems && Object.entries(cqItems).map(function (_ref) {
    var _ref2 = (0, _slicedToArray2.default)(_ref, 2),
      key = _ref2[0],
      value = _ref2[1];
    var panelTitle = value['cq:panelTitle'],
      rest = (0, _objectWithoutProperties2.default)(value, _excluded);
    return _objectSpread({
      title: panelTitle,
      name: key
    }, rest);
  });
  // activeIndex is a number with the selected tab which comes from component wrapper as WebinarTabs
  var activeIndex = propsToUse.activeIndex;
  var tabs = (0, _react.useMemo)(function () {
    return HTabItems !== null && HTabItems !== void 0 ? HTabItems : [];
  }, [HTabItems]);
  var hasTabs = tabs.length !== 0;
  var queryParam = props.queryParam || 'selected-panel';
  var searchURL = isBrowser ? window.location.search : '';
  var searchParams = new URLSearchParams(searchURL);
  var currentParameter = searchParams.get(queryParam);
  var setActiveTabParameter = (0, _react.useCallback)(function (index) {
    var _tabs$index;
    var param = (_tabs$index = tabs[index]) === null || _tabs$index === void 0 ? void 0 : _tabs$index.itemParameter;
    if (param) {
      setQueryParam(queryParam, param);
    }
  }, [queryParam, tabs]);
  var _useState2 = (0, _react.useState)(function () {
      if (aemProps) {
        var childKeys = tabs.map(function (content) {
          return stripPathFromKey(content.name ? content.name : '');
        });
        var doesActiveItemExist = childKeys.indexOf(activeItem) > -1;
        return doesActiveItemExist ? childKeys.indexOf(activeItem) : 0;
      }
      if (queryParam && currentParameter) {
        var foundSelectedTab = tabs.findIndex(function (tab) {
          return tab.itemParameter === currentParameter;
        });
        if (foundSelectedTab > -1) {
          return foundSelectedTab;
        }
      }
      return 0;
    }),
    value = _useState2[0],
    setValue = _useState2[1];
  (0, _react.useEffect)(function () {
    if (activeIndex) {
      setValue(activeIndex);
    }
  }, [activeIndex]);
  (0, _react.useEffect)(function () {
    setShowLoader(showHorizontaltabLoader);
  }, [showHorizontaltabLoader]);
  (0, _react.useEffect)(function () {
    setActiveTabParameter(value);
  }, [setActiveTabParameter, value]);
  var handleChange = function handleChange(e, newValue) {
    setValue(newValue);
    (propsToUse === null || propsToUse === void 0 ? void 0 : propsToUse.setSelectedTab) && (propsToUse === null || propsToUse === void 0 ? void 0 : propsToUse.setSelectedTab(newValue));
  };
  var handleTitleUpdate = function handleTitleUpdate(tabItem, title) {
    if (isAemEditMode || isAemPreviewMode) return title;
    var buyAgainItem = tabItems && tabItems.find(function (item) {
      return item === null || item === void 0 ? void 0 : item.isBuyAgain;
    });
    if (buyAgainItem && buyAgainItem.name === tabItem.name) {
      if (userIsLoggedIn && isBuyAgainEmpty) {
        return translations.popularProducts;
      }
    }
    return title;
  };
  return __jsx("div", {
    className: classes.root
  }, __jsx(_Tabs.default, {
    classes: {
      indicator: classes.indicator
    },
    value: value,
    onChange: handleChange,
    TabIndicatorProps: {
      children: __jsx("span", null)
    },
    indicatorColor: "primary",
    variant: "scrollable",
    scrollButtons: "auto",
    "aria-label": "Tab Navigation Menu",
    className: classes.tabsContainer
  }, hasTabs && tabs.map(function (tab, i) {
    var title = __jsx(_Typography.default, {
      component: "div",
      className: classes.tabTitle,
      dangerouslySetInnerHTML: {
        __html: handleTitleUpdate(tab, tab.title)
      }
    });
    if (showLoader && !isAemEditMode && !isAemPreviewMode) return __jsx(_Tab.default, {
      key: "htab-skeleton-loader-".concat(i),
      label: __jsx(_lab.Skeleton, {
        width: "100%",
        variant: "text",
        height: 50,
        animation: "wave"
      }),
      disabled: true
    });
    return __jsx(_Tab.default, (0, _extends2.default)({
      "data-cmp-hook-tabs": "tab",
      key: "htab-".concat(i),
      className: (0, _clsx.default)(classes.tab, 'cmp-tabs__tab'),
      label: title
    }, a11yProps(i)));
  })), hasTabs && children && Array.isArray(children) && children.map(function (child, i) {
    return __jsx(_TabPanel.default, {
      key: "htab-panel-".concat(i),
      index: i,
      isTabSelected: value === i,
      isWebinars: (props === null || props === void 0 ? void 0 : props.isWebinars) || false
    }, child);
  }));
};
var _default = HorizontalTab;
exports.default = _default;